"use client";

import styles from "./VerificationSteps.module.scss";
import { useEffect, useMemo } from "react";
import { createForm } from "@/stores";
import { useSteps } from "@/hooks";
import {
  VerificationEmailVerifyStep,
  VerificationPhoneOptionalStep,
  WelcomeOnPlatform,
} from "..";
import { Flex } from "@vetty/ui";

const VERIFICATION_FORM_FIELDS: string[] = [
  "phonePrefix",
  "phoneNumber",
  "code",
];

/**
 * Auth-only verification: email OTP → optional phone → welcome.
 * Billing/subscription steps stay out of this product slice.
 */
export const VerificationSteps = () => {
  const { currentStep } = useSteps();

  const STEP_COMPONENTS = {
    1: VerificationEmailVerifyStep,
    2: VerificationPhoneOptionalStep,
    3: WelcomeOnPlatform,
  } as const;

  type StepNumber = keyof typeof STEP_COMPONENTS;

  useEffect(() => {
    createForm(VERIFICATION_FORM_FIELDS);
  }, []);

  const CurrentStepComponent = useMemo(() => {
    return STEP_COMPONENTS[currentStep as StepNumber];
  }, [currentStep]);

  return (
    <Flex
      style={{ overflowY: currentStep === 3 ? "visible" : "scroll" }}
      direction={"column"}
      justify={"center"}
      className={styles["comp"]}
    >
      {CurrentStepComponent ? <CurrentStepComponent /> : null}
    </Flex>
  );
};
